var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateAgreements({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 228",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 228,
    fill: "#EEF6F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 48,
    width: 160,
    height: 140,
    rx: 6,
    fill: "#C8E6EA",
    stroke: "#3AA9AE",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 160,
    height: 140,
    rx: 6,
    fill: "#D8EEEF",
    stroke: "#3AA9AE",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 32,
    width: 160,
    height: 140,
    rx: 6,
    fill: "#ffffff",
    stroke: "#3AA9AE",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 54,
    width: 110,
    height: 10,
    rx: 3,
    fill: "#3AA9AE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 76,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#A8D8DB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 76,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#A8D8DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 92,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#C8E6EA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 92,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#C8E6EA"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 108,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#A8D8DB"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 108,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#A8D8DB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 124,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#C8E6EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 124,
    width: 48,
    height: 7,
    rx: 2,
    fill: "#C8E6EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 120,
    r: 52,
    fill: "#3AA9AE",
    opacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 120,
    r: 38,
    fill: "#3AA9AE",
    opacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 132,
    fontFamily: "Segoe UI, Arial",
    fontSize: 44,
    fontWeight: 700,
    fill: "#3AA9AE",
    textAnchor: "middle"
  }, "\u20AC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateAgreements);
export default __webpack_public_path__ + "static/media/rate-agreements.1caf602ee10abe0366db929bb6891996.svg";
export { ForwardRef as ReactComponent };